module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07505_banner_800x600.0a809ae3.png";